import {integratedSignUpMutation} from './integrated-sign-up.mutation'
import {phoneLoginLinkMutation} from './phone-login-link.mutation'
import {phoneLoginVerifyMutation} from './phone-login-verify.mutation'
import {signUpMutation} from './sign-up.mutation'
import {userSignInCheckQuery} from './user-email-check.query'

export const AuthQueries = {
  UserSignInCheckQuery: userSignInCheckQuery,
  signUpMutation,
  phoneLoginVerifyMutation,
  phoneLoginLinkMutation,
}

export const AuthMutations = {integratedSignUpMutation}
